import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { activeProfileFor, userProfileHome } from "@/lib/accountProfiles";

export default function RequireProfile({ allow, children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "admin" || allow.includes(activeProfileFor(user))) return children;
  return <Navigate to={userProfileHome(user)} replace />;
}
